import styled from 'styled-components';
import ArrowDownIcon from '../../../../../Icons/ArrowDownIcon';
import ArrowRightNew from '../../../../../Icons/RIghtArrowIconHome';

export const OfferBlockLoader = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto;
    width:38.7rem;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
    margin: 0 0 ${props.theme.spacing.xlarge} 0;
  
  `,
);

export const ArrowDownWrap = styled(ArrowDownIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill:#898b91;
    margin:0 0 ${props.theme.spacing.custom(8)} 0;
`,
);

export const offerBlockHeader = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:3.7rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: ${props.theme.spacing.large} ${props.theme.spacing.base} 0 ${props.theme.spacing.base} ;
  
  `,
);

export const InternalOfferWrapper = styled.div(
  props => `

    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    margin: ${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.xlarge};
  
  `,
);

export const OfferCouponOuter = styled.div(
  props => `
    display:flex;
    justify-content:space-between;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base} ${props.theme.spacing.xlarge};
  
  `,
);

export const CouponCode = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:3.7rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const OfferDetailsWrap = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    padding: ${props.theme.spacing.large} ${props.theme.spacing.xlarge};
  
  `,
);

export const CouponCodeApplied = styled.div(
  props => `
    display:flex;
    width:8.3rem;
    height:3.7rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const OfferDetails = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:2.3rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const OfferDescription = styled.div(
  props => `
    display:flex;
    width:24rem;
    height:2.3rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const PromoCodeWrapper = styled.div(
  props => `

    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    margin: ${props.theme.spacing.nospacing} ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.base};
  `,
);

export const ViewAllPromoWrap = styled.div(
  props => `
    display:flex;
    justify-content:space-between;
    padding:${props.theme.spacing.large} ${props.theme.spacing.xlarge};
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  `,
);

export const EnterPromo = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:2.3rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const ViewAllPromo = styled.div(
  props => `
    display:flex;
    width:10.7rem;
    height:2.3rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const EnterPromoWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    justify-content: space-between;
    padding:${props.theme.spacing.large};
  `,
);

export const PromoEnterInput = styled.input(
  props => `
      display: inline-flex;
      width:100%;
      border: none;
      font-size: ${props.theme.font.custom(14)};
      border-radius: ${props.theme.misc.borderRadius.base};
      border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
      
      ::placeholder {
        color: ${props.theme.colors.downriver.light};
        padding: ${props.theme.spacing.base};
        font-size: ${props.theme.font.custom(14)};
        font-weight:bold;
      }
      &:focus{
        box-shadow: none;
        outline-offset: 0;
        outline: 0;
      }
  
    `,
);

export const EnterPromoInnerWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:88%;
  
  `,
);

export const ArrowRightOuter = styled.div(
  props => `
    display:flex;
    justify-content:center;
    align-items:center;
    background:${props.theme.colors.downriver.light};
    border-radius: ${props.theme.misc.borderRadius.base};
    width:3.8rem;
    height:3.8rem;
  `,
);

export const ArrowRightWrap = styled(ArrowRightNew)(
  props => `
        width:1rem;
        height:1rem;
        fill:${props.theme.colors.ash.base};
    `,
);
